import { useInitActionCombo } from '../../../commons/combobox/initActionCombo.js';

import { useRemoteCombobox } from '@/setup/remoteCombobox.js';
import { reactive, getCurrentInstance, ref, computed } from 'vue';

export const useCAReceiptDataCommon = () => {
  const { proxy } = getCurrentInstance();
  const { comboboxLoadData, submitQuickAdd } = useRemoteCombobox();

  // Tạo object lưu dữ liệu các field
  const comboboxDataRemote = reactive({
    budget_source_name: [],
    budget_chapter_code: [],
    budget_sub_kind_item_code: [],
    budget_item_code: [],
    project_code: [],
    bank_account: [],
    activity_name: [],
    statistic_code: [],
    debit_account: [],
    credit_account: [],
    accounting_object_code: [],
    purchase_purpose_id: [],
    budget_sub_item_code: [],
    purchase_purpose_code: [],
    topic_code: [],
    task_code: [],
    typeOfFundComboConfig: [],
  });

  // toggle detail
  const toggleAbove = ref(true);
  const toggleAboveHandler = () => {
    toggleAbove.value = !toggleAbove.value;
  };

  const toggleAboveHandlerGrid = (colIndex, rowIndex) => {
    if (
      toggleAbove.value &&
      ((proxy._defaultRow && rowIndex >= proxy._defaultRow) || (!proxy._defaultRow && rowIndex >= 3))
    ) {
      toggleAbove.value = false;
    }
  };

  // Active tab hạch toán hay thống kê
  const selectedTab = ref(1);
  const currentLayout = ref('CAReceiptDetail')
  const selectedTabHandler = value => {
    selectedTab.value = value;
  };

  //#region khởi tạo config cho combox trong grid
  const {
    budgetSourceComboConfig,
    budgetChapterComboConfig,
    budgetSubKindItemComboConfig,
    budgetItemComboConfig,
    budgetSubItemComboConfig,
    accountingObjectComboConfig,
    activityComboConfig,
    statisticComboConfig,
    bankAccountComboConfig,
    purchasePurposeComboConfig,
    typeOfFundComboConfig,
    budgetKindItemComboConfig,
    budgetDetailItemComboConfig,
    topicComboConfig,
    budgetProvideComboConfig,
    budgetFeesComboConfig,
    fundStructureComboConfig,
    TaskComboConfig,
    contractComboConfig,
    onAccountingObjectComboboxLoadData,
    accountComboMostDetailConfig,
    projectComboConfig,
    accountComboParalellConfig,
    projectExpenseComboConfig
  } = useInitActionCombo(comboboxDataRemote, comboboxLoadData);
  //#endregion

  return {
    comboboxDataRemote,
    toggleAbove,
    toggleAboveHandler,
    selectedTab,
    currentLayout,
    selectedTabHandler,
    budgetSourceComboConfig,
    budgetChapterComboConfig,
    budgetSubKindItemComboConfig,
    budgetItemComboConfig,
    budgetSubItemComboConfig,
    accountingObjectComboConfig,
    activityComboConfig,
    statisticComboConfig,
    bankAccountComboConfig,
    purchasePurposeComboConfig,
    typeOfFundComboConfig,
    budgetKindItemComboConfig,
    budgetDetailItemComboConfig, // func combo
    submitQuickAdd,
    comboboxLoadData,
    toggleAboveHandlerGrid,
    topicComboConfig,
    budgetProvideComboConfig,
    budgetFeesComboConfig,
    fundStructureComboConfig,
    TaskComboConfig,
    contractComboConfig,
    onAccountingObjectComboboxLoadData,
    accountComboMostDetailConfig,
    projectComboConfig,
    accountComboParalellConfig,
    projectExpenseComboConfig
  };
};
